<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.BRFNoFilter ||
              Filter.EnqNoFilter ||
              Filter.agentFilter ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.TransportTypeFilter ||
              Filter.ShipemntTypeFilter ||
              Filter.billingTypeFilter ||
              Filter.billingForFilter ||
              Filter.CSTeamFilter ||
              Filter.contractNoFilter ||
              Filter.fk_ccbm_id ||
              Filter.commodityHsnCodeFilter ||
              Filter.EMPFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.createdByFilter ||
              Filter.updatedByFilter ||
              Filter.branchFilter ||
              Filter.createdAtRange.startDate ||
              Filter.createdAtRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.BRFNoFilter ||
                  Filter.EnqNoFilter ||
                  Filter.agentFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.TransportTypeFilter ||
                  Filter.ShipemntTypeFilter ||
                  Filter.billingTypeFilter ||
                  Filter.billingForFilter ||
                  Filter.CSTeamFilter ||
                  Filter.contractNoFilter ||
                  Filter.fk_ccbm_id ||
                  Filter.commodityHsnCodeFilter ||
                  Filter.EMPFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdByFilter ||
                  Filter.updatedByFilter ||
                  Filter.branchFilter ||
                  Filter.createdAtRange.startDate ||
                  Filter.createdAtRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getBookingResp.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getBookingResp', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
          <b-col cols="6"> </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.createdAtRange"
                    :startDate="startDate" :endDate="endDate" :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getBookingRespDash('Normal', '0', '0', '1', '1')"></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>BRF NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search BRF NO Filter"
                    id="BRFNoFilter" name="BRFNoFilter" autocomplete="off" v-model="Filter.BRFNoFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Enq No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Enq No Filter"
                    id="EnqNoFilter" name="EnqNoFilter" autocomplete="off" v-model="Filter.EnqNoFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Transport Type</label>
                  <model-list-select :list="transportTypeList" v-model="Filter.TransportTypeFilter" option-value="value"
                    option-text="value" placeholder="Select Transport Type"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Shipment Type</label>
                  <model-list-select :list="shipmentTypeList" v-model="Filter.ShipemntTypeFilter" option-value="value"
                    option-text="value" placeholder="Select Shipment Type"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Status</label>
                  <model-list-select :list="statusList" v-model="Filter.statusFilter" option-value="pTypeVal"
                    option-text="pTypeText" placeholder="Select Status"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Billing Type</label>
                  <model-list-select :list="BillingTypeList" v-model="Filter.billingTypeFilter" option-value="inv"
                    option-text="int" placeholder="Select Billing Type"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <!-- <b-col md="3">
                  <label>Booking For</label>
                  <model-list-select
                    :list="BookingForList"
                    v-model="Filter.billingForFilter"
                    option-value="bkgval"
                    option-text="bkgtxt"
                    placeholder="Select Status"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col> -->
                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Client</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Agent</label>
                  <model-list-select :list="$store.getters['common/getAllAgentColoaderList']" id="agentFilter"
                    v-model="Filter.agentFilter" option-value="agntColoaderId" option-text="agentName"
                    placeholder="Select Agent Name"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                    v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>RA Number</label>
                  <model-list-select :list="$store.getters['common/getAllContractList']" id="contractNoFilter"
                    v-model="Filter.contractNoFilter" option-value="value" option-text="label" placeholder="All"
                    @input="getContractNoBasedVessel(Filter.contractNoFilter); getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label for="blType">Vessel Name :</label>
                  <model-list-select class="ml-1" :list="$store.getters['common/getAllContractBasedVesselList']"
                    id="vessel_name" v-model="Filter.fk_ccbm_id" option-value="value" option-text="label"
                    placeholder="Select Vessel Name" @input="getBookingRespDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>EMPTY PICK UP</label>
                  <model-list-select :list="Filter.TransportTypeFilter == 'CRC'
                    ? $store.getters[
                    'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                    ]
                    : Filter.TransportTypeFilter == 'EXPORT'
                      ? $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                      ]
                      : $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
                      ]
                    " id="EMPFilter" v-model="Filter.EMPFilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="All" @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>POR</label>
                  <model-list-select :list="Filter.TransportTypeFilter == 'CRC'
                    ? $store.getters[
                    'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                    ]
                    : Filter.TransportTypeFilter == 'EXPORT'
                      ? $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                      ]
                      : $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
                      ]
                    " id="PORFilter" v-model="Filter.PORFilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="All" @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POL</label>
                  <model-list-select :list="Filter.TransportTypeFilter == 'CRC'
                    ? $store.getters[
                    'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                    ]
                    : Filter.TransportTypeFilter == 'EXPORT'
                      ? $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                      ]
                      : $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
                      ]
                    " id="POLFilter" v-model="Filter.POLFilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="All" @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POD</label>
                  <model-list-select :list="Filter.TransportTypeFilter == 'CRC'
                    ? $store.getters[
                    'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                    ]
                    : Filter.TransportTypeFilter == 'EXPORT'
                      ? $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                      ]
                      : $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
                      ]
                    " id="PODFilter" v-model="Filter.PODFilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="All" @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>FPOD</label>
                  <model-list-select :list="Filter.TransportTypeFilter == 'CRC'
                    ? $store.getters[
                    'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                    ]
                    : Filter.TransportTypeFilter == 'EXPORT'
                      ? $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                      ]
                      : $store.getters[
                      'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
                      ]
                    " id="FPODFilter" v-model="Filter.FPODFilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="All" @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>

                <b-col md="3">
                  <label>
                    <b> CS Team/Sales Person </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="CSTeamFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')" v-model="Filter.CSTeamFilter"
                    option-value="userId" option-text="employeeName"
                    placeholder="Select CS Team/Sales Person"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName"
                    placeholder="Select Created User"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Updated By User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="updatedByFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')" v-model="Filter.updatedByFilter"
                    option-value="userId" option-text="employeeName"
                    placeholder="Select Cleared User"></model-list-select>
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :items="getBookingResp" :fields="BookingResponseFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">
                <!-- Default Row Data -->
                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>

                <template slot="BookingNo" slot-scope="row1">
                  <strong>BRF No:</strong>{{ row1.item.BookingNo }}<br />
                  <strong>BRF Date:</strong> {{ row1.item.JobDate }}<br />
                  <strong>Enq No:</strong>{{ row1.item.EnquiryNo }}<br />
                  <strong>Enq Pricing No:</strong>{{ row1.item.EnqPricingNo }}<br />
                  <strong>Client Name:</strong> {{ row1.item.ClientName }}<br />
                  <strong>Shipping Line:</strong> {{ row1.item.ShippingLine }}<br />
                  <strong>Transport Type:</strong> {{ row1.item.TransportType }}<br />
                  <strong>Shipemnt Type:</strong> {{ row1.item.ShipemntType }}<br />
                  <strong>Billing Type:</strong> {{ row1.item.BillingType }}<br />
                </template>

                <template slot="EmptyPickup" slot-scope="row1">
                  <strong>Empty Pickup:</strong> {{ row1.item.EmptyPickup }}<br />
                  <strong>POR:</strong> {{ row1.item.Por }}<br />
                  <strong>POL:</strong> {{ row1.item.Pol }}<br />
                  <strong>POD:</strong> {{ row1.item.Pod }}<br />
                  <strong>FPOD:</strong> {{ row1.item.Fpod }}<br />
                  <strong>Humidity:</strong> {{ row1.item.Humidity }}<br />
                  <strong>Cargo Weight:</strong> {{ row1.item.CargoWeight }}<br />
                  <strong>Spot NonSpot:</strong> {{ row1.item.SpotNonSpot }}<br />
                  <strong>Ra Number:</strong> {{ row1.item.RaNumber }}<br />
                  <strong>Rate Agreed:</strong> {{ row1.item.RateAgreed }}<br />
                  <strong>SI CUT OFF:</strong> {{ row1.item.SiCutOfDate }}<br />
                  <strong>FREIGHT TERMS ( MBL):</strong> {{ row1.item.FreightTermsMbl }}<br />
                  <strong>FREIGHT TERMS HBL:</strong> {{ row1.item.FreightTermsHbl }}<br />
                  <strong>DESTINATION CHARGES:</strong> {{ row1.item.DestinationCharges }}<br />
                  <strong>DESTINATION CHARGES Det.:</strong> {{ row1.item.DestinationChargesDet }}<br />
                  <strong>FIRST MILE BOOKING:</strong> {{ row1.item.FirstMileBooking }}<br />
                </template>

                <template slot="CommodityItemName" slot-scope="row1">
                  <strong>Commodity Item Name:</strong> {{ row1.item.CommodityItemName
                  }}<br />
                  <strong>Commodity Hsn Code:</strong> {{ row1.item.CommodityHsnCode
                  }}<br />
                  <strong>Commodity Item HsnCode:</strong>
                  {{ row1.item.CommodityItemHsnCode }}<br />
                  <strong>Agent Type:</strong> {{ row1.item.AgentCategoryType }}<br />
                  <strong>Agent Name:</strong> {{ row1.item.AgentName }}<br />
                  <strong>Container Type:</strong> {{ row1.item.continerTypeDet }}<br />
                  <strong>Tues Count:</strong> {{ row1.item.TuesCount }}<br />
                </template>

                <template slot="HandoverDate" slot-scope="row1">
                  <strong>ETD:</strong> {{ row1.item.Etd }}<br />
                  <strong>Handover Date:</strong> {{ row1.item.HandoverDate }}<br />
                  <strong>Valid For Sail:</strong> {{ row1.item.ValidForSail }}<br />
                  <strong>Valid Till:</strong> {{ row1.item.ValidTill }}<br />
                  <strong>Country Name:</strong> {{ row1.item.CurrencyCountryName }}<br />
                  <strong>Currency Name:</strong> {{ row1.item.MasterCurrencyCode }}<br />
                  <strong>Delivery Mode:</strong> {{ row1.item.DeliveryMode }}<br />
                  <strong>Quotation Till:</strong> {{ row1.item.QuotationTillStatus
                  }}<br />
                </template>

                <template slot="IsUsed" slot-scope="row1">
                  <strong>Temperature Required:</strong> {{ row1.item.TemperatureRequired
                  }}<br />
                  <strong>Un Number:</strong> {{ row1.item.UnNumber }}<br />
                  <strong>Imdg Class:</strong> {{ row1.item.ImdgClass }}<br />
                  <strong>Packing Code:</strong> {{ row1.item.PackingCode }}<br />
                  <strong>Other Commodity:</strong> {{ row1.item.OtherCommodity }}<br />
                  <strong>Commodity Type:</strong> {{ row1.item.CommodityType }}<br />
                  <strong>Inco Term:</strong> {{ row1.item.IncoTerm }}<br />

                  <strong>Bl Instruction:</strong> {{ row1.item.BlInstruction }}<br />
                  <strong>PDA:</strong> {{ row1.item.Pda }}<br />
                  <strong>Free Days:</strong> {{ row1.item.FreeDays }}<br />
                </template>

                <template slot="CreatedAt" slot-scope="row1">
                  <strong>Created By:</strong> {{ row1.item.CreatedByUser }}<br />
                  <strong>Created Date:</strong> {{ row1.item.CreatedAt }}<br />
                  <strong>Updated By:</strong> {{ row1.item.UpdatedByUser }}<br />
                  <strong>Updated Date:</strong> {{ row1.item.UpdatedAt }}<br />
                  <strong>Raised From:</strong> {{ row1.item.RaisedFrom }}<br />
                  <strong>Remarks:</strong> {{ row1.item.Remarks }}<br />
                  <strong>Is Used:</strong> {{ row1.item.IsUsed }}<br />
                  <strong>Is Active:</strong> {{ row1.item.IsActive }}<br />
                  <strong>Is Deleted:</strong> {{ row1.item.IsDeleted }}<br />
                  <strong>Is Enq Pricing Closed:</strong> {{ row1.item.IsEnqPricingClosed
                  }}<br />
                  <strong>Is Enq Pricing Used:</strong> {{ row1.item.IsEnqPricingUsed
                  }}<br />
                  <strong>Is Enq Pricing Active:</strong> {{ row1.item.IsEnqPricingActive
                  }}<br />
                  <b-button v-if="$route.path == '/booking-resp-list'" @click="DuplicateBookingResp(row1.item, 'edit')"
                    size="xxl" style="font-size: 0.675rem" :disabled="isSubmited" variant="outline-success">
                    <md-spinner v-if="isSubmited" md-indeterminate style="width: 20px; height: 20px"></md-spinner>
                    Edit BRF

                  </b-button>
                  <b-button v-if="$route.path == '/booking-resp-list'"
                    @click="DuplicateBookingResp(row1.item, 'duplicate')" size="xxl" style="font-size: 0.675rem"
                    :disabled="isSubmited" variant="outline-success">
                    <md-spinner v-if="isSubmited" md-indeterminate style="width: 20px; height: 20px"></md-spinner>
                    Duplicate BRF

                  </b-button>
                  <ToggleBRFSwitch v-if="row1.item.prbr_id > 0 && row1.item.booking_id > 0"
                    :brf_no="row1.item.BookingNo" :booking_no="row1.item.ConsoleBookingNo"
                    :booking_id="row1.item.booking_id" :prbr_id="row1.item.prbr_id"
                    :isbookingactive="row1.item.isbookingactive" :prbr_is_active="row1.item.prbr_is_active"
                    :request_type="'BRF'" @success="getBookingRespDash" />
                  <BRFCard v-if="row1.item.prbr_id > 0" :BRFDetails="row1.item" :prbr_id="Number(row1.item.prbr_id)" />
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import BRFCard from "../common/brfCard.vue";
import ToggleBRFSwitch from "./ToggleBRFSwitch.vue";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    console.log(
      "this.$router.history.current.fullPath=>",
      this.$router.history.current.fullPath
    );

    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),
      this.$store.dispatch("common/setAllAgentColoaderList"),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({ itemCode: "ContainerTypeList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePODDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEnginePODDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineFPODDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineFPODDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePOLDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEnginePOLDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePORDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEnginePORDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineCrossCountryLocationDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineCrossCountryDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPODDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineIMPPODDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPOLDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineIMPPOLDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPFPODDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineIMPFPODDDList" })
      ),
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPORDDList",
        JSON.stringify({ itemCode: "getAllEnqPriceEngineIMPPORDDList" })
      ),
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),
      this.$store.dispatch("common/setAllContractList", {
        filter: "ContractList",
        active: "all",
        isAll: 1,
        cb_is_active: 1,
        cb_is_deleted: 0,
        isSelectedColumn: 1,
      }),
      this.$store.dispatch("common/setAllContractBasedVesselList", {
        filter: "ContractVesselList",
        active: "all",
        isAll: 0,
        ccbm_is_active: 1,
        ccbm_is_deleted: 0,
        isSelectedColumn: 0,
        // isSelectedColumn: 1,
        fk_cb_id: 0,
        is_withoutcb: 1,
      }),
    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(5000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function
        if (
          this.$sessionsStorage.get("booking_resp_frt_enq_id") &&
          this.$sessionsStorage.get("is_new_book_resp")
        ) {
          // this.getEnquiryPrcingBookingRespList(
          //   "Normal",
          //   this.$sessionsStorage.get("booking_resp_frt_enq_id"),
          //   this.$sessionsStorage.get("is_new_book_resp")
          // );
        }
      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getBookingRespDash("Normal", "0", "0", "1", "1");
    }
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getBookingResp: [],
      totalData: 0,

      BookingResponseFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "BookingNo",
          mainkey: "BookingNo",
          label: "Booking Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "EmptyPickup",
          mainkey: "EmptyPickup",
          label: "Loc Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "CommodityItemName",
          mainkey: "CommodityItemName",
          label: "Commodity Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "HandoverDate",
          mainkey: "HandoverDate",
          label: "Dates",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "HandoverDate",
          mainkey: "HandoverDate",
          label: "Dates",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "IsUsed",
          mainkey: "IsUsed",
          label: "Others",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "CreatedAt",
          mainkey: "CreatedAt",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      BookingForList: [
        {
          bkgval: "Agent",
          bkgtxt: "Agent",
        },
        {
          bkgval: "Client",
          bkgtxt: "Client",
        },
      ],
      BillingTypeList: [
        {
          inv: "1",
          int: "Local Billing Only",
        },
        {
          inv: "2",
          int: "Overseas Billing Only",
        },
        {
          inv: "3",
          int: "LOCAL AND OVERSEAS BILLING",
        },
      ],
      statusList: [
        {
          pTypeVal: "0",
          pTypeText: "In-Active",
        },
        {
          pTypeVal: "1",
          pTypeText: "Active",
        },
        {
          pTypeVal: "2",
          pTypeText: "All",
        },
      ],
      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      transportTypeList: [
        {
          text: "EXPORT",
          value: "EXPORT",
        },
        {
          text: "IMPORT",
          value: "IMPORT",
        },
        {
          text: "CROSS COUNTRY",
          value: "CRC",
        },
      ],
      Filter: {
        BRFNoFilter: "",
        EnqNoFilter: "",
        agentFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        ShipemntTypeFilter: "",
        billingTypeFilter: "",
        billingForFilter: "",
        CSTeamFilter: "",
        contractNoFilter: "",
        fk_ccbm_id: "",
        commodityHsnCodeFilter: "",
        EMPFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        updatedByFilter: "",
        branchFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      createdAtRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      isSubmited: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
    BRFCard,
    ToggleBRFSwitch,
  },
  computed: {},
  watch: {},
  methods: {
    getContractNoBasedVessel(fk_contract_idFilter) {
      this.$store.dispatch("common/setAllContractBasedVesselList", {
        filter: "ContractVesselList",
        active: "all",
        isAll: 0,
        ccbm_is_active: 1,
        ccbm_is_deleted: 0,
        isSelectedColumn: 0,
        // isSelectedColumn: 1,
        fk_cb_id: fk_contract_idFilter,
        is_withoutcb: 1,
      });
    },
    DuplicateBookingResp(item, type) {
      this.$sessionsStorage.set("booking_resp_frt_enq_id", item.prbr_id);
      this.$sessionsStorage.set("booking_resp_edit_type", type);
      this.$sessionsStorage.set("freight_enq_no", "");
      this.$sessionsStorage.set("is_new_book_resp", "1");
      this.$sessionsStorage.set("is_duplicate", "1");
      this.$router.push({
        path: "/pricing/upsert-new-booking-resp/1/0",
      });
      // item.is_duplicate=1;
      // this.isLoading = true;

      // this.isSubmited = true;
      // NodeLockPannelService.saveNewBookingResp(item)
      // .then((response) => {
      //   const { data, status, statusText } = response;

      //   if (status == 200 && data) {
      //     this.isSubmited = false;
      //     this.alert.content = data.MSG;
      //     this.goFreightEnq();

      //   }
      //   this.isSubmited = false;
      //   this.isLoading = false;
      // })
      // .catch((error) => {
      //   this.isSubmited = false;
      //   console.log("Catch on DuplicateBookingResp Error: ", error);
      // });
    },
    goFreightEnq() {
      this.$router.push({
        path: "/enqPrice/FreightEnq",
      });
    },
    clearFilter() {
      this.Filter = {
        BRFNoFilter: "",
        EnqNoFilter: "",
        agentFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        ShipemntTypeFilter: "",
        billingTypeFilter: "",
        billingForFilter: "",
        CSTeamFilter: "",
        contractNoFilter: "",
        fk_ccbm_id: "",
        commodityHsnCodeFilter: "",
        EMPFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        updatedByFilter: "",
        branchFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getBookingRespDash("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.createdAtRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getBookingRespDash(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.totalData = 0;
      this.getBookingResp = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getBookingResp",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        record_type: "BOOKING_RESPONSE",
        is_client_template: 0,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllNewBookingRespList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data.data);
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              // const url = window.URL.createObjectURL(new Blob([data]));

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "BRFData.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getBookingRespDash("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.total;
                this.getBookingResp = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getBookingRespDash("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getBookingRespDash("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBookingRespDash("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      console.log("event=>", event);
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBookingRespDash("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// bookingRespDash.vue?788dc924